import { AfterViewInit, Component, EventEmitter, Inject, Input, LOCALE_ID, Output, PLATFORM_ID } from '@angular/core';
import { take, takeUntil } from 'rxjs/operators';
import { InitialDataService } from 'src/app/services/page/initial-data.service';
import { BasePageComponent } from '../../base-page/base-page.component';
import { CookieService } from 'ngx-cookie-service';
import { ActivatedRoute, Router } from '@angular/router';
import { HOST_NAME } from 'src/app/global.tokens';
import { UntypedFormControl } from '@angular/forms';
import { LoginStatusService } from 'src/app/services/auth/login/login-status.service';
import { LoggedStatus, UserFullInfo } from 'src/app/services/auth/login/login.models';
import { gameInfoTrx, gameTrx, liveCasinoTrx, loginTrx, signUpTrx, sportsBookTrx } from 'src/app/router-translation.labels';
import { TranslationConfig } from 'src/app/utils/translate-config';
import { Language } from 'src/app/apollo/models/base-models';
import { LicenceService } from 'src/app/services/utils/licence.service';
import { DocumentData, documentData, SectionCard, sectionsData, Status, UserDocumentsResponse } from 'src/app/services/profile/upload-documents.models';
import { UploadDocumentsService } from 'src/app/services/profile/upload-documents.service';
import { PendingWithdrawalService } from 'src/app/services/payment/withdrawal/pending-withdrawal.service';
import { PendingWithdrawalList } from 'src/app/services/payment/withdrawal/withdrawal.models';
import { UserMessagesService } from 'src/app/services/user-messages/user-messages.service';
import { PendingRewardsService } from 'src/app/services/prizes/pending-rewards.service';
import { PendingReward } from 'src/app/services/prizes/prizes.models';
import { UserFullInfoService } from 'src/app/services/auth/check-session/user-full-info.service';
import { isPlatformBrowser } from '@angular/common';
import { SearchGameComponent } from '../../games/search-game/search-game.component';
import { MatDialog } from '@angular/material/dialog';
import { extractLanguageCode, languageSwitchUrl } from 'src/app/utils/language-switch.utils';
import { hasRaffleAccess } from '../../ticket-lottery/raffle-access.utils';
import { DetectDeviceService } from 'src/app/services/utils/detect-device.service';
import { InstallPromptService, isAppMenuItem } from 'src/app/services/pwa/install-prompt.service';

@Component({
  selector: 'app-desktop-sidenav',
  templateUrl: './desktop-sidenav.component.html',
  styleUrls: ['./desktop-sidenav.component.scss']
})
export class DesktopSidenavComponent extends BasePageComponent implements AfterViewInit {
  @Output() closeNav = new EventEmitter();
  @Input() toggle: boolean;
  childData: any;
  allMenuItems: any[] = [];
  deferredPrompt: any;
  currentUrl: string;
  languagelist = new UntypedFormControl('');
  isLogin: boolean = false;
  public userDocumentData: SectionCard[];
  hasDocumentRequest: boolean;
  pendingList: PendingWithdrawalList;
  unreadMessages: number = 0;
  pendingRewardsList:PendingReward[];
  userRole: boolean;
  canSeeRaffle: boolean = false;

  _isVisible: boolean = false;

  @Input() set isVisible(value: boolean) {
    this._isVisible = value;
  }

  get isVisible(): boolean {
    return this._isVisible;
  }

  sportsBookUrl: string = this.translationConfig.getTranslation(sportsBookTrx);
  liveCasinoRoute: string = `/${this.translationConfig.getTranslation(liveCasinoTrx)}`;
  slot: string = `/${this.translationConfig.getTranslation(gameTrx)}`;
  selectedLanguage: Language;
  userInfo: UserFullInfo; 
  constructor(
    public initialData: InitialDataService,
    private router: Router,
    private cookie: CookieService,
    private activeRoute: ActivatedRoute,
    protected loginStatus: LoginStatusService,
    protected translationConfig: TranslationConfig,
    private documentService: UploadDocumentsService,
    protected licenceService: LicenceService,
    private pendingListService: PendingWithdrawalService,
    @Inject(HOST_NAME) public hostName,
    @Inject(LOCALE_ID) public locale,
    @Inject(PLATFORM_ID) private platformId,
    private userMessagesService: UserMessagesService,
    private pendinRewardsService: PendingRewardsService,
    private userFullInfoService: UserFullInfoService,
    public dialog: MatDialog,
    public detectDeviceService: DetectDeviceService,
    private installPromptService: InstallPromptService,
  ) { super(); }

  ngOnInit(): void {
    this.installPromptService.deferredPrompt$.pipe(takeUntil(this.unsubscribe)).subscribe(prompt => {
      this.deferredPrompt = prompt;
      if (this.childData?.topMenuItems) {
        const canInstall = this.detectDeviceService.canShowAppMenu(this.deferredPrompt);
        this.childData = { ...this.childData, topMenuItems: canInstall ? this.allMenuItems : this.filterMenuItems() };
      }
    });

    this.loginStatus.getIfUserLogged().pipe(takeUntil(this.unsubscribe)).subscribe(resp => {
      this.isLogin = true;
      if (this.isLogin) {
        this.documentService.updateUserDocuments();
        this.documentService.getUserDocuments().pipe(takeUntil(this.unsubscribe)).subscribe((userDocumentsResponse: UserDocumentsResponse) => {
          if (userDocumentsResponse) {
            this.userDocumentData = this.documentService.fillSectionCards(sectionsData, userDocumentsResponse, this.documentService.getSectionsCookie());
            this.hasDocumentRequest = !!this.userDocumentData.find((item) => !(item.status === this.documentService.translateStatus(Status.Approved) || item.status === this.documentService.translateStatus(Status.NotRequired)) && !item.is_hide);
          }

        });

        setTimeout(() => { // Side Nav count notifications api calls here
          this.pendingWithdrawalCheck();
        }, 0);
      }
    })
      this.initialData.fetchData().pipe(takeUntil(this.unsubscribe)).subscribe(resp => {
        this.allMenuItems = resp.topMenuItems || [];
        const canInstall = this.detectDeviceService.canShowAppMenu(this.deferredPrompt);
        this.childData = { ...resp, topMenuItems: canInstall ? this.allMenuItems : this.filterMenuItems() };
        // console.log(this.childData.topMenuItems)
        this.selectedLanguage = resp.languages.filter(item => {
          const parts = item.name.split("-"); 
          const langCode = parts[0] === "Lemon" && parts.length > 1 ? parts.slice(1).join().trim() : parts.join('-').trim();
          return langCode.toLowerCase() === this.locale.toLowerCase();
        })[0];
      })
    // this.userFullInfoService.requestFullInfo(true).pipe(takeUntil(this.unsubscribe)).subscribe({
    //   next: (res) => {
    //     this.userInfo = res;
    //   },
    //   error: () => { },
    //   complete: () => { },
    // })
    this.loginStatus.getUserLoginStatus().pipe(takeUntil(this.unsubscribe)).subscribe({
      next: (res) => {
        this.userInfo = res.fullInfo;
        const roleList = (res.fullInfo?.roles as string[]) || [];
        this.userRole = roleList.some(role => this.loginStatus.vipRoles.includes(role.toLowerCase()));
        this.canSeeRaffle = hasRaffleAccess(roleList);
      }
    })
  }

  closeSideNav() {
    this.closeNav.emit('');
  }

  // english is a js only link so google cannot see it, the rest stay normal html links
  languageHref(item: any): string | null {
    if (languageSwitchUrl(item?.name)) {
      return null;
    }
    return item?.redirectUrl ? item.redirectUrl : null;
  }

  onLanguageClick(event: MouseEvent, item: any): void {
    const url = languageSwitchUrl(item?.name);
    if (url) {
      event.preventDefault();
      window.location.href = url;
      return;
    }
    if (item?.redirectUrl) {
      event.preventDefault();
      window.location.href = item.redirectUrl;
    }
  }

  setCookie($event: any) {
    const langCode = extractLanguageCode($event?.value);
    if (!langCode) {
      return;
    }
    this.cookie.set('language', langCode, 2592000, '/', this.hostName);
    const url = languageSwitchUrl($event?.value);
    if (url) {
      window.location.href = url;
      return;
    }
    const selected = this.childData?.languages?.find((item) => item?.name === $event?.value);
    if (selected?.redirectUrl) {
      window.location.href = selected.redirectUrl;
    }
  }

  signup() {
    this.router.navigate(['', this.translationConfig.getTranslation(signUpTrx)], { state: { redirectTo: this.router.url } });
    this.closeSideNav();
  }

  login() {
    this.router.navigate(['', this.translationConfig.getTranslation(loginTrx)], { state: { redirectTo: this.router.url } });
    this.closeSideNav();
  }

  pendingWithdrawalCheck() {
    if (this.isLogin) {
      this.pendingListService.getList().subscribe();
      this.pendingListService.pendingWithdrawalsCount$.pipe(takeUntil(this.unsubscribe)).subscribe({
        next: (resp) => {
          this.pendingList = resp;
        },
        error: (error) => {
          // console.log(error)
        }
      });
      this.userMessagesService.unreadMessagesCount.pipe(takeUntil(this.unsubscribe)).subscribe((unreadCount) => {
        this.unreadMessages = unreadCount;
      });
      this.pendinRewardsService.getPendingRewards().pipe(takeUntil(this.unsubscribe)).subscribe((resp) => {
        this.pendingRewardsList = resp;
      });
    }
  }

  ngAfterViewInit() {
    // Side Nav count notifications api calls here
    this.pendingWithdrawalCheck();
  }

  openSearchDialog() {
    if (isPlatformBrowser(this.platformId)) {
      const dialogRef = this.dialog.open(SearchGameComponent, {
        width: '646px',
        height: '80vh',
        backdropClass: 'search-blur-backdrop',
        panelClass: ['transparent', 'search-wrapper']
      });
    }

    this.closeSideNav();
  }

  // app menu item is visible only when the browser offers install (deferredPrompt), i.e. app not installed yet
  // safari never fires beforeinstallprompt, so it is shown there unless opened as the installed app
  filterMenuItems(): any[] {
    return this.allMenuItems.filter(menu => !isAppMenuItem(menu));
  }

}
